import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=53162160&scoped=true&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"
import style0 from "./detailList.vue?vue&type=style&index=0&id=53162160&prod&scoped=true&lang=less&"
import style1 from "./detailList.vue?vue&type=style&index=1&id=53162160&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53162160",
  null
  
)

export default component.exports